import { render, staticRenderFns } from "./FabricListModal.vue?vue&type=template&id=7d32d15f&scoped=true"
import script from "./FabricListModal.vue?vue&type=script&lang=js"
export * from "./FabricListModal.vue?vue&type=script&lang=js"
import style0 from "./FabricListModal.vue?vue&type=style&index=0&id=7d32d15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d32d15f",
  null
  
)

export default component.exports